import { useState, useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDispatch } from 'react-redux';
import { actionsToHideModal } from '../../redux/actions/AppHeaderModalActions';

export const HotKeys = ({ children }) => {
  const dispatch = useDispatch();
  const [showEditingFeatures, setShowEditingFeatures] = useState();
  const [showTranscripts, setShowTranscripts] = useState();

  useHotkeys('shift+t', () => {
    setShowTranscripts(showEditingFeatures =>
      showEditingFeatures === undefined || showEditingFeatures === false
        ? true
        : false
    );
  });

  useHotkeys('shift+e', () => {
    setShowEditingFeatures(showEditingFeatures =>
      showEditingFeatures === undefined || showEditingFeatures === false
        ? true
        : false
    );
  });

  useEffect(() => {
    if (showEditingFeatures !== undefined) {
      if (!showEditingFeatures) {
        document.body.classList.remove('cms');
      } else {
        document.body.classList.add('cms');
      }
    }
  }, [showEditingFeatures]);

  useEffect(() => {
    if (showTranscripts !== undefined) {
      if (!showTranscripts) {
        document.body.classList.remove('transcripts');
      } else {
        document.body.classList.add('transcripts');
      }
    }
  }, [showTranscripts]);

  useHotkeys('esc', () => {
    // close all modals (search, bookmarks, etc)
    dispatch(actionsToHideModal('CLOSE_MODAL'));

    // look for expanded media items
    let expandedMedia = document.querySelector('.expand-btn.isExpanded');
    // if media is expanded
    if (expandedMedia) {
      // close it by programatically clicking it
      expandedMedia.click();
    }
  });
  return children;
};
